import React from 'react'
import { Link } from 'gatsby' 

import style from './Source.module.scss'
import { FiChevronRight, FiMenu } from 'react-icons/fi'

const Breadcrumbs = ({
  page,
  pages,
  setDisplaySidebar
}) => (
  <>
    <div className={style.breadcrumbs}>
      <FiMenu className={style.menuButton} onClick={() => setDisplaySidebar(display => !display)} />
      { pages.map(p => (
        <React.Fragment key={p.id}>   
          <Link to={ p.path }>
            { p.title }
          </Link>
          <FiChevronRight /> 
        </React.Fragment> 
      ))}
      <strong>{ page.title }</strong>
    </div>
  </>  
)

export default Breadcrumbs